module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.2527/img/callout-wave.svg"